import { ReactElement, ReactNode, useState } from "react"
import { useParams } from "react-router-dom"
import { v4 as uuid4 } from "uuid"

import AmendEbDeviceProvider from "./baseProviders/amendEbDeviceProvider"
import useStartNewEbDeviceAmendment from "../../../../../services/middleware/hooks/devices/lct/useStartNewEbDeviceAmendment"

interface INewEbDeviceAmendmentFormUrlParams {
    deviceRef: string
}

interface INewEbDeviceAmendmentProviderProps {
    children: ReactNode
}

const NewEbDeviceAmendmentProvider = ({
    children,
}: INewEbDeviceAmendmentProviderProps): ReactElement => {
    const { deviceRef: urlDeviceRef } = useParams<
        keyof INewEbDeviceAmendmentFormUrlParams
    >() as INewEbDeviceAmendmentFormUrlParams

    const [attachmentUUID] = useState<string>(uuid4())

    const {
        data,
        setData,
        isLoading,
        error: newEbDeviceAmendmentError,
    } = useStartNewEbDeviceAmendment(urlDeviceRef, attachmentUUID)

    return (
        <AmendEbDeviceProvider
            formData={data}
            setFormData={setData}
            formDataIsLoading={isLoading}
            formDataError={newEbDeviceAmendmentError}
            attachmentUUID={attachmentUUID}
            systemReference={urlDeviceRef}
        >
            {children}
        </AmendEbDeviceProvider>
    )
}

export default NewEbDeviceAmendmentProvider
